var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarRepair48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00098 21.8672H41.0331C43.0862 21.8672 44.7505 23.5315 44.7505 25.5845V32.0899H5.71833C3.66529 32.0899 2.00098 30.4256 2.00098 28.3725V21.8672Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9241 31.6254C15.9241 33.9352 14.0516 35.8074 11.7425 35.8074C9.43258 35.8074 7.56006 33.9352 7.56006 31.6254C7.56006 29.3156 9.43258 27.4434 11.7425 27.4434C14.0516 27.4434 15.9241 29.3156 15.9241 31.6254Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0862 31.6254C40.0862 33.9352 38.2137 35.8074 35.9046 35.8074C33.5947 35.8074 31.7222 33.9352 31.7222 31.6254C31.7222 29.3156 33.5947 27.4434 35.9046 27.4434C38.2137 27.4434 40.0862 29.3156 40.0862 31.6254Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7109 14.979C14.3269 14.1638 15.6626 13.5029 16.6904 13.5029H25.4144C26.4439 13.5029 27.7851 14.1733 28.3939 14.979L33.5985 21.867H8.50635L13.7109 14.979Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5986 21.8667L39.0433 16.422C39.6291 15.8362 40.5789 15.8362 41.1647 16.422L41.9627 17.22",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarRepair48);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarRepair48.9f854d8d205fc4061bbc6fe2daaa4cd8.svg";
export { ForwardRef as ReactComponent };